export function parseIsoDate(dateString?: string): Date | null {
	let date;
	try {
		date = dateString ? new Date(dateString) : null;
	} catch (error) {
		console.error(error);
		date = null;
	}
	return date;
}

export function formatDate(date?: Date | null, endDate?: Date | null): string {
	if (!date || date.getFullYear() < 1900) {
		return '';
	}

	const dateFormat: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	};

	let dateString = date.toLocaleString('en-GB', dateFormat);
	if (endDate) {
		dateString += ` - ${endDate.toLocaleString('en-GB', dateFormat)}`;
	}

	return dateString;
}
